import { Injectable, inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
    private authService = inject(AuthService);

    can(project: string, module: string, action: string): boolean {
        const perms = this.authService.getUser()?.permissions;
        if (!perms) return false;
        const key = `${project}:${module}`;
        return perms[key]?.includes(action) ?? false;
    }

    hasAnyPermission(project: string): boolean {
        const perms = this.authService.getUser()?.permissions;
        if (!perms) return false;
        return Object.keys(perms).some(k => k.startsWith(`${project}:`));
    }

    getActions(project: string, module: string): string[] {
        const perms = this.authService.getUser()?.permissions;
        if (!perms) return [];
        return perms[`${project}:${module}`] ?? [];
    }
}
